module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/electoral-college-convenes-desktop.svg?v=3b32c825";